import { QueryClient } from "@tanstack/react-query";
import { api } from "./api";

// Helper to handle axios errors and extract message similarly to the previous fetch implementation
async function throwIfResNotOk(res) {
  // Axios throws on non-2xx by default, but we can double check if needed.
  // In axios, the error is usually caught in the catch block.
  // This helper might not be needed if we rely on axios default behavior,
  // but let's keep the structure for getQueryFn.
}

export async function apiRequest(method, url, data) {
  const res = await api.request({
    method,
    url,
    data,
  });
  return res;
}

export const getQueryFn = ({ on401: unauthorizedBehavior }) =>
  async ({ queryKey }) => {
    try {
      const res = await api.get(queryKey.join("/"));
      return res.data;
    } catch (error) {
      if (unauthorizedBehavior === "returnNull" && error.response?.status === 401) {
        return null;
      }
      // Re-throw to be handled by react-query
      throw error;
    }
  };

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryFn: getQueryFn({ on401: "throw" }),
      refetchInterval: false,
      refetchOnWindowFocus: false,
      staleTime: Infinity,
      retry: false,
    },
    mutations: {
      retry: false,
    },
  },
});
